var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SYSVAR_INSTRUCTIONS_PUBKEY, SystemProgram, } from "@solana/web3.js";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { SPL_ACCOUNT_COMPRESSION_PROGRAM_ID, SPL_NOOP_PROGRAM_ID, } from "@solana/spl-account-compression";
import { SOLANA_SPL_ATA_PROGRAM_ID, TOKEN_METADATA_PROGRAM } from "../../utils/const";
import { PROGRAM_ID as MPL_BUBBLEGUM_PROGRAM_ID } from "@metaplex-foundation/mpl-bubblegum";
import { getCNFTData } from "../../utils/getCNFTData.function";
export function getCancelCNftInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, creatorHash, dataHash, index, merkleTree, nonce, proofMeta, root, treeAuthority;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getCNFTData({
                        connection: Data.program.provider.connection,
                        tokenId: Data.tokenId.toBase58(),
                        Cluster: Data.clusterOrUrl.includes("mainnet") ? "mainnet-beta" : "devnet",
                    })];
                case 1:
                    _a = _b.sent(), creatorHash = _a.creatorHash, dataHash = _a.dataHash, index = _a.index, merkleTree = _a.merkleTree, nonce = _a.nonce, proofMeta = _a.proofMeta, root = _a.root, treeAuthority = _a.treeAuthority;
                    return [4 /*yield*/, Data.program.methods
                            .cancelCNft(Data.swapIdentity.swapDataAccount_seed, Data.swapIdentity.swapDataAccount_bump, root, dataHash, creatorHash, nonce, index)
                            .accounts({
                            systemProgram: SystemProgram.programId,
                            metadataProgram: TOKEN_METADATA_PROGRAM,
                            sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                            splTokenProgram: TOKEN_PROGRAM_ID,
                            splAtaProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                            swapDataAccount: Data.swapIdentity.swapDataAccount_publicKey,
                            user: Data.user,
                            signer: Data.signer,
                            leafDelegate: Data.signer,
                            treeAuthority: treeAuthority,
                            merkleTree: merkleTree,
                            logWrapper: SPL_NOOP_PROGRAM_ID,
                            compressionProgram: SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
                            bubblegumProgram: MPL_BUBBLEGUM_PROGRAM_ID,
                        })
                            .remainingAccounts(proofMeta)
                            .instruction()];
                case 2: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
